'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompareTo = function () {
  function CompareTo() {
    'ngInject';

    _classCallCheck(this, CompareTo);

    this.require = 'ngModel';
    this.restrict = 'A';
    this.scope = {
      otherModelValue: '=compareTo'
    };
  }

  _createClass(CompareTo, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      $scope.$watch('otherModelValue', function () {
        ctrl.$validate();
      });

      ctrl.$validators.compareTo = function (modelValue) {
        return modelValue === $scope.otherModelValue;
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      'ngInject';

      return new CompareTo();
    }
  }]);

  return CompareTo;
}();

exports.default = CompareTo;


// WEBPACK FOOTER //
// ./common/directives/validation/compare-to.js